export default "__VITE_ASSET__CAVRPN8U__"